import { render, staticRenderFns } from "./F4.vue?vue&type=template&id=060e693e&scoped=true"
import script from "./F4.vue?vue&type=script&lang=js"
export * from "./F4.vue?vue&type=script&lang=js"
import style0 from "./F4.vue?vue&type=style&index=0&id=060e693e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e693e",
  null
  
)

export default component.exports